import { cn } from '@/lib/utils';

type AlertDialogHeaderProps = React.ComponentProps<'div'>;

export const AlertDialogHeader = ({
  className,
  ...props
}: AlertDialogHeaderProps) => (
  <div
    data-slot="alert-dialog-header"
    className={cn(
      'tw-grid tw-grid-rows-[auto_1fr] tw-place-items-center tw-gap-1.5 tw-text-center has-data-[slot=alert-dialog-media]:tw-grid-rows-[auto_auto_1fr] has-data-[slot=alert-dialog-media]:tw-gap-x-4 sm:group-data-[size=default]/alert-dialog-content:tw-place-items-start sm:group-data-[size=default]/alert-dialog-content:tw-text-left sm:group-data-[size=default]/alert-dialog-content:has-data-[slot=alert-dialog-media]:tw-grid-rows-[auto_1fr]',
      className,
    )}
    {...props}
  />
);
